import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "./App.scss";
import AppContext from "./components/GlobalContext";
import Homepage from "./components/Homepage";
import * as data from "./components/data.json";
import Profile from "./components/Profile";
import Spinner from "./components/Spinner";
import MovieItem from "./components/Movies/MovieItem";
import MovieContainer from "./components/Movies/MovieContainer";
const Similar = React.lazy(() => import("./components/Similar"));
const MovieDetails = React.lazy(() => import("./components/MovieDetails"));
const App = () => {
  const {
    poster_path,
    id,
    original_title: title,
    release_date,
  } = data.results[0];
  return (
    <AppContext.Provider value={{}}>
      <Router>
        <Suspense fallback={<Spinner height="100vh" />}>
          <Switch>
            {/* <Route path="/profile" exact component={Profile} /> */}
            <Route
              path="/:id"
              exact
              render={(props) => {
                return <MovieDetails {...props} />;
              }}
            />
            <Route
              path="/:id/similar"
              render={(props) =>
                props.location.state ? (
                  <Similar {...props} />
                ) : (
                  <Redirect to={`/${props.match.params.id}`} />
                )
              }
            />
            <Route path="/" exact component={Homepage} />
            <Route
              path="*"
              render={() => (
                <div>
                  <h2>You're on a wrong page</h2>
                </div>
              )}
            />
          </Switch>
        </Suspense>
      </Router>
    </AppContext.Provider>
  );
};
export default App;
